"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24PeopleGroupFill = function Svg24PeopleGroupFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M15.498 20H3.5A1.5 1.5 0 0 1 2 18.5C2 14.65 6.24 13 9.5 13c3.255 0 7.492 1.648 7.5 5.498 0 .83-.673 1.502-1.502 1.502zM21 19a1.5 1.5 0 0 0 1.5-1.5 4.503 4.503 0 0 0-.115-.833c-.108-.43-.322-.999-.748-1.567-.903-1.205-2.521-2.1-5.137-2.1-.384 0-.747.02-1.089.056 1.784 1.198 3.084 3.255 3.089 5.44 0 0 0 .219-.041.504H21z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 7.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zM16.5 12a4 4 0 1 0-1.835-7.555c.53.895.835 1.94.835 3.055 0 1.422-.495 2.73-1.322 3.758A3.982 3.982 0 0 0 16.5 12z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24PeopleGroupFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24PeopleGroupFill;
exports.default = _default;